module.exports = __webpack_public_path__ + "img/logos.8fd83fc4.png";